module.exports = __webpack_public_path__ + "static/media/greencell.1310db67.svg";